import { TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Edit } from "lucide-react";
import type { Client } from "@/pages/Dashboard/Clients";

interface ClientsTableRowProps {
  client: Client;
  onEdit: (client: Client) => void;
}

export const ClientsTableRow = ({ client, onEdit }: ClientsTableRowProps) => {
  const getSourceBadge = () => {
    if (!client.source) return null;
    
    const variants = {
      manual: { label: 'Manual', variant: 'default' as const },
      signup: { label: 'Signed Up', variant: 'secondary' as const },
      service_request: { label: 'Service Request', variant: 'outline' as const }
    };
    
    const config = variants[client.source];
    return <Badge variant={config.variant}>{config.label}</Badge>;
  };

  return (
    <TableRow>
      <TableCell>
        <div className="flex items-center gap-2">
          {client.name}
          {getSourceBadge()}
        </div>
      </TableCell>
      <TableCell>{client.email || "-"}</TableCell>
      <TableCell>{client.phone || "-"}</TableCell>
      <TableCell>{client.company || "-"}</TableCell>
      <TableCell>
        <div className="flex gap-1 flex-wrap">
          {client.service_types?.map((service) => (
            <Badge key={service} variant="outline">
              {service}
            </Badge>
          ))}
        </div>
      </TableCell>
      <TableCell className="text-right">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onEdit(client)}
          disabled={client.source !== 'manual'}
          title={client.source !== 'manual' ? 'Can only edit manually added clients' : 'Edit client'}
        >
          <Edit className="h-4 w-4" />
        </Button>
      </TableCell>
    </TableRow>
  );
};